import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { LanguageSwitcher } from '@components';
import { useDirection } from '@hooks';
import { Trans } from '@libs/i18n';
import { TranslateIcon } from '@phosphor-icons/react';
import { NoFlipTypography } from '@utils';

export const LanguageTab: FC = observer(() => {
  const { dir } = useDirection();
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, gap: 1.5 }}>
        <TranslateIcon size={28} color="primary.main" />
        <NoFlipTypography
          mode={dir}
          variant="h5"
          component="h2"
          sx={{
            fontWeight: 400,
            color: 'text.primary',
          }}
        >
          <Trans i18nKey={'app.settings.section.language.title'} />
        </NoFlipTypography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 3,
          borderRadius: 2,
          backgroundColor: 'grey.100',
          border: 1,
          borderColor: 'grey.400',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: 'grey.400',
            borderColor: 'grey.700',
          },
        }}
      >
        <Box>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 600,
              color: 'text.primary',
              mb: 0.5,
            }}
          >
            <Trans i18nKey={'app.settings.section.language.applang'} />
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
            }}
          >
            <Trans i18nKey={'app.settings.section.language.desc'} />
          </Typography>
        </Box>
        <LanguageSwitcher variant="dropdown" />
      </Box>
    </Box>
  );
});
